import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalServiceContentDto } from '@nx-frontend/shared/types';

export interface GetPortalContentsParams {
  path: string;
  portalDomain: string;
}

export async function getPortalContents(params: GetPortalContentsParams): Promise<PortalServiceContentDto> {
  const queryParams = buildQuery(params);
  const query = queryParams ? `?${queryParams}` : '';
  const { data } = await axiosClient.get(`${generalEnv.nextCommonApiUrl}/portal/contents${query}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data;
}
